import { useContext } from "react"
import { RespostasPersonalizadasIzzaContext } from "./RespostasPersonalizadasIzzaContext"

export function useRespostasPersonalizadasIzzaContext() {
    return useContext(RespostasPersonalizadasIzzaContext)
}
